archive.classy.controller({
    name: 'ArchiveSubNavbarController',
    inject: ['$scope', '$location', 'ApplicationService', 'ApplicationsSubNavbarService', 'ResetModalService', '$state', 'FeedbackModalService',
    '$stateParams', 'ResetService', 'TabsService', 'authServiceFactory', 'MainContentService', 'TabsService', '$timeout', 'SliderService', 'SliderFactory',
    'DetermineAwardService', 'AccountModelService', 'DateService', 'BinFactory', '$modal', 'CommitteeModeModelService', 'ParentCommentsModelService'],
    init: function() {
        this.$.AccountModelService = this.AccountModelService;
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.TabsService = this.TabsService;
        this.$.ResetModalService = this.ResetModalService;
        this.$.ApplicationService = this.ApplicationService;
        this.$.FeedbackModalService = this.FeedbackModalService;
        this.$.ResetService  =this.ResetService;
        this.$.SliderService = this.SliderService;
        this.$.$state = this.$state;
        this.$.ApplicationsSubNavbarService = this.ApplicationsSubNavbarService;
        if (typeof this.$stateParams.applicationID !== 'undefined') {
            this.ApplicationsSubNavbarService._loadApplication(this.$stateParams.applicationID);
            /*
            if (this.CommitteeModeModelService.get()[0].active==1) {
                console.log("is in here");
                this.socketApp.emit('newapp', this.$stateParams.applicationID); 
            }}
            */ 
        }
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.DetermineAwardService = this.DetermineAwardService;
        this.$.confidential = this.authServiceFactory.getAuth().permissions.confidential;
    },
    watch: {
        'ApplicationService.getApplicationID()': function(value)
        {
            if (this.ApplicationService.getApplicationID() !== undefined)
            {
                this.$.applicants = this.ApplicationService.getAwardData().applicants;
                this.$.applicationID = this.ApplicationService.getApplicationID();
                this._FlagsReminders();
            }
        }
    },
    openNotes: function()
    {
        this.SliderService.pushSlider(new this.SliderFactory('applicationsSubNavbar/partials/notesRemindersTab','Notes & Reminders','m'));
    },
    getBin: function()
    {
        if (this.ApplicationService.getAwardData() !== undefined)
        {
            if (this.ApplicationService.getAwardData().app[0].App_Fin_Year == this.DateService.getCurrentYear() + 1)
                return "Future";
            else if (this.ApplicationService.getAwardData().app[0].Status_New == 1)
                return "New";
            else if (this.ApplicationService.getAwardData().app[0].Status_Consider == 1)
                return "Considering";
            else if (this.ApplicationService.getAwardData().app[0].Status_Award == 1 && Number(this.ApplicationService.getAwardData().applicants[0].ActAward)>0)
                return "Awarded";
            else if (this.ApplicationService.getAwardData().app[0].Status_Unfinished == 1)
                return "Unfinished";
            else if (this.ApplicationService.getAwardData().app[0].Status_Viewed == 1)
                return "Viewed";
            else if (this.ApplicationService.getAwardData().app[0].Status_Reject == 1 || (this.ApplicationService.getAwardData().app[0].Status_Award == 1 && Number(this.ApplicationService.getAwardData().applicants[0].ActAward)==0))
                return "Non-Awarded";
            else 
                return "";
        }
    },
    _FlagsReminders:function()
    {
        var result = this.ApplicationService.getAwardData();
        this.$.flags = result.flags;
        this.$.notes = result.notes;
        this.$.reminders = result.reminders;
    },
    archive: function()
    {
        this.$modal.open({
            templateUrl: "fast/submodules/schoolside/applications/submodules/applicationsSubNavbar/partials/archiveModal.html?v=" + versionNo,
            controller: "ArchiveModalController",
            backdrop: 'static',
            keyboard: false
        });
    },
    getField: function(item, field)
    {
        if (typeof item['x' + field] == 'undefined' || item['x' + field] === null || item['x' + field] == '' || item[field] == item['x' + field])
            return item[field] 
        else
            return item['x' + field];
    }
});
